<template>
  <div class="register">
    <div class="register__container">
      <div class="register__brand">
        <img class="tingg-brand-logo" src="https://developer.tingg.africa/checkout/v2/assets/images/tingg/tingg_white.png" alt="Tingg"/>
      </div>

      <div class="register__card row no-gutters">
        <div class="col-md-6">
          <ul class="wizard-vertical">
            <li class="wizard-vertical__step active">
              <span class="wizard-vertical__step__count">1</span> Profile Information
            </li>
            <li class="wizard-vertical__divider"></li>
            <li class="wizard-vertical__step active">
              <span class="wizard-vertical__step__count">2</span> Business Information
            </li>
            <li class="wizard-vertical__divider"></li>
            <li class="wizard-vertical__step active">
              <span class="wizard-vertical__step__count">3</span> Complete
            </li>
          </ul>
        </div>

        <div class="col-md-6">
          <div class="register__prompt text-center">
            <i class="material-icons" id="tingg-email-complete">mail_outline</i>
            <div class="register__prompt-text">
              A confirmation message has been sent to
              <span id="registration-email">{{ userInformation.emailAddress }}</span>.
              Check your email and follow the instructions to activate your account.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  const logInfo = !!(process.env.NODE_ENV !== 'production')

  export default {
    beforeRouteEnter (to, from, next) {
      next(vm => {
        logInfo && console.log('Was the registration complete?', vm.$store.state.registration.complete)
        if (!vm.$store.state.registration.complete) {
          return next({
            path: '/register/user',
            query: {
              redirect: to.fullPath
            }
          })
        }
      })
    },

    computed: {
      ...mapGetters('registration', ['userInformation'])
    },

    methods: {
      ...mapActions('registration', ['clearMemory'])
    },

    name: 'RegisterComplete'
  }
</script>

<style lang="scss">
  @import "../styles/theme";

  .register {
    width: 100%;
    min-height: 100vh;
    border-radius: 2px;

    display: flex;
    align-items: start;
    justify-content: center;

    background-image: linear-gradient(to bottom right, $tingg-primary-red, $tingg-purple);
  }

  #tingg-email-complete {
    font-size: 96px;
    color: $tingg-primary-red;
  }

  .register__container {
    @include make-col-ready();

    @include media-breakpoint-down(xl) {
      @include make-col(8);
    }

    @include media-breakpoint-down(md) {
      @include make-col(10);
    }

    @include media-breakpoint-down(sm) {
      @include make-col(10);
    }

    @include media-breakpoint-down(xs) {
      @include make-col(12);
    }

    height: 75%;
    margin-top: 2.5rem;
  }

  .register__card {
    width: 100%;
    height: 100%;
    background-color: $background-white;
    padding: 1.5rem 3rem;
  }

  .register__card-title {
    width: 100%;
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .register__brand {
    width: 100%;
    margin-bottom: 2.5rem;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .register__prompt-text {
    font-size: 21px;
    font-weight: 500;
    line-height: 2rem;
    text-align: center;

    #registration-email {
      color: $tingg-primary-red
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/RegisterComplete.vue